"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuotePartialAddressWithZip = exports.AddressTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.AddressTransport = typebox_1.Type.Object({
    addressLine1: typebox_1.Type.String(),
    addressLine2: typebox_1.Type.Optional(typebox_1.Type.String()),
    city: typebox_1.Type.String(),
    state: typebox_1.Type.String(),
    zip: typebox_1.Type.String(),
    country: typebox_1.Type.String({
        pattern: '^[A-Za-z]{2}$', // Enforce that country is exactly 2 letters
    }),
});
exports.QuotePartialAddressWithZip = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.AddressTransport, ['zip']),
    typebox_1.Type.Partial(typebox_1.Type.Omit(exports.AddressTransport, ['zip'])),
]);
//# sourceMappingURL=address-transport.js.map